export const slides = [
    {
      title: "Kevin D'Angello - The Oldskool Vibe",
      description: "Dutch recording label Revealed is not resting on its laurels after recently hitting the milestone of its 1000th release. Maintaining its laser focus on delivering slamming dancefloor bangers, the iconic imprint now unreleases the latest white-hot track from Kevin D'Angello's title, 'The Oldskool Vibe'.",
      image: "https://static.vecteezy.com/system/resources/thumbnails/037/044/052/small_2x/ai-generated-studio-shot-of-black-headphones-over-music-note-explosion-background-with-empty-space-for-text-photo.jpg",
      buttonName: "Listen Now"
    },
    {
      title: "Experience the Serenity",
      description: "Dive into a world of calm and peace with our latest audio experience. Perfect for relaxation and meditation.",
      image: "https://png.pngtree.com/thumb_back/fh260/background/20230612/pngtree-pair-of-headphones-on-the-water-at-nighttime-image_2931863.jpg",
      buttonName: "Listen Now"
    },
    {
      title: "Color Your Sound",
      description: "Add some vibrant colors to your listening experience with our latest headphones.",
      image: "https://t3.ftcdn.net/jpg/05/62/98/36/360_F_562983674_524xR5Rzurt8MjTQghCvNYBcyeuvLHPE.jpg",
      buttonName: "Listen Now"
    },
    {
      title: "Deep Bass Experience",
      description: "Feel the power of the deep bass with our state-of-the-art headphones, designed for music enthusiasts.",
      image: "https://c4.wallpaperflare.com/wallpaper/21/815/720/music-the-city-style-landscape-80s-hd-wallpaper-preview.jpg",
      buttonName: "Listen Now"
    },
    {
      title: "Rainy Day Vibes",
      description: "Perfect for those cozy rainy days, our headphones offer a warm and rich sound experience.",
      image: "https://img.freepik.com/premium-photo/wet-dark-red-headphones-with-red-blue-light-reflections-rain-it_668856-843.jpg",
      buttonName: "Listen Now"
    }
  ];